import { LANGUAGE } from '~/__gql__/graphql';

export const DEFAULT_LANGUAGE = LANGUAGE.en;
